import ActiveComparison from '@/components/Comparison/ActiveComparison';
import * as React from 'react';
export default {
  ActiveComparison,
  React
};